import { Extension } from "@tiptap/core";

/**
 * Adds a `listStyle` attribute to bullet/ordered lists, rendered as a
 * `data-list-style` attribute the rich-text CSS styles per type:
 * bulleted | numbered | checkmark | steps.
 */
export const ListStyle = Extension.create({
    name: "listStyle",
    addGlobalAttributes() {
        return [
            {
                types: ["bulletList", "orderedList"],
                attributes: {
                    listStyle: {
                        default: null,
                        parseHTML: (el) =>
                            (el as HTMLElement).getAttribute("data-list-style"),
                        renderHTML: (attrs) =>
                            attrs.listStyle
                                ? { "data-list-style": attrs.listStyle }
                                : {},
                    },
                },
            },
        ];
    },
});
